import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';
import styled from 'styled-components';
import Image from '@nubank/nuds-web/components/Image/Image';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
import { useParallax } from 'react-scroll-parallax';
import Grid from '@nubank/nuds-web/components/Grid/Grid';

import Collapsable from './Collapsable';
import ContentBox from './ContentBox';

const StyledCardBackgroundImagesContainer = styled.div`
  align-items: start;
  display: flex;
  gap: 17px;
  justify-content: center;
  max-width: 1391px;
  margin: 0 auto;

  @media (width >= 1150px) {
    gap: 0;
  }
`;

const StyledSubtitleTypography = styled(Typography)`
  @media (width >= 1150px) {
    font-size: 1.5rem;
  }
`;

function CardRates() {
  const { ref } = useParallax({
    easing: [0.9, 0.95, 1, 1.1],
  });

  return (
    <Box
      tag="section"
      height="100%"
      width="100%"
      marginBottom={{ xs: '32px', lg: '100px' }}
      paddingHorizontal={{ xs: '0', lg: '56px' }}
    >
      <Grid
        paddingLeft={{ xs: '0', lg: '0' }}
        paddingRight={{ xs: '0', lg: '0' }}
      >

        <Grid.Child
          gridColumn={{ xs: '1 / span 4', md: '2 / span 4', lg: '2 / span 10' }}
          gridRow="1"
        >

          {/* CARD BACKGROUND IMAGES */}

          <StyledCardBackgroundImagesContainer ref={ref}>
            <Image
              alt="Nubank"
              srcSet={{
                xs: 'credit-card/rates/image-left-xs.jpg',
                lg: 'credit-card/rates/image-left-lg.jpg',
              }}
              maxHeight={{ xs: '452px', lg: '100%' }}
              loading="lazy"
              webp
            />
            <ContentBox displayOptions={{ xs: 'none', lg: 'block' }} />
            <Image
              alt="Nubank"
              srcSet={{
                xs: 'credit-card/rates/image-right-xs.jpg',
                lg: 'credit-card/rates/image-right-lg.jpg',
              }}
              maxHeight={{ xs: '452px', lg: '100%' }}
              loading="lazy"
              webp
            />
          </StyledCardBackgroundImagesContainer>

          {/* CONTENT */}

          <ContentBox displayOptions={{ xs: 'block', lg: 'none' }} />

          {/* CONTENT ROWS */}

          <Box
            paddingHorizontal={{ xs: '32px', lg: '100px' }}
            marginTop="60px"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems={{ xs: 'left', lg: 'center' }}
          >
            <StyledSubtitleTypography
              variant="heading3"
              marginBottom={{ xs: '32px' }}
              marginTop={{ xs: '0', lg: '32px' }}
            >
              Lee cómo está calculado
            </StyledSubtitleTypography>
            <Link
              href="https://cdn.nubank.com.br/MX/folleto-informativo.pdf"
              iconProps={{ name: 'arrow-down' }}
              target="_blank"
            >
              Folleto informativo
            </Link>
          </Box>

          <Collapsable />
        </Grid.Child>
      </Grid>

    </Box>
  );
}

export default CardRates;
